module.exports = __webpack_public_path__ + "6d361cb98547d95d705def4b3d7c977b.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/avatars/josh.jpg
// module id = 42
// module chunks = 0